import groq from 'groq'

export default groq`{
  _id,
  _type,
  size,
  targetProductSkus,
  limitedTargetProductSkus
}`
